// extracted by mini-css-extract-plugin
export default {"container":"Unsubscribe_container__4ym31","txtMsg":"Unsubscribe_txtMsg__xZVwd","card":"Unsubscribe_card__ATJpD"};